import { StylePropItem } from '@wix/thunderbolt-becky-root'
import _ from 'lodash'
import { convertStyleProp } from './utils/convertStyleProps'

type Style = {
	id: string
	type: string
	style: { properties: { [prop: string]: StylePropItem } }
}

export const stylePropsToCssVars = (style: any): Record<string, string | number> => {
	const styleProps = (style as Style).style.properties || (style as Style).style

	const { spx } = style
	const cssVars = _.reduce(
		styleProps,
		(acc: Record<string, string | number>, styleProp, propName) => {
			const converterVars = convertStyleProp(styleProp, propName, spx)
			Object.assign(acc, converterVars)
			return acc
		},
		{}
	)

	return cssVars
}
